<template>
<!-- 同步大班课 -->
  <div class="addclass">
    <div class="content">
      <div class="cont-mid">
        <el-form ref="form" :rules="rules" :model="form" label-width="200px">
          <el-form-item label="课节名称：" prop="name">
            <el-input
              v-model="form.name"
              maxlength="100"
              show-word-limit
              style="width:555px"
              :disabled="isDisable"
            ></el-input>
          </el-form-item>
          <el-form-item label="上课时间：" required>
            <dateTimePikcer @dateTimePicker="handleTimeChange" 
                            :endTime="form.lessonsEndTime"
                            :beginTime="form.lessonsBeginTime"
                            :isDisabled="isDisable">
            </dateTimePikcer>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="13">
              <el-form-item label="授课老师：" :required="true" >
                <teacherSelect :requestType="'teacher'" 
                               :role.sync="form.teacherRole"
                               :selected.sync="form.teacher.id"
                               :courseId="Number(form.courseProjectId)"
                               @teacherSelect="handleTeacherChange" 
                               :isDisabled="isDisable"/>
              </el-form-item>
            </el-col>
            <el-col :span="11">
               <teacherSelect :requestType="'assistant'" 
                              :role.sync="form.assistantRole"
                              :selected.sync="form.assistant.id"
                              :courseId="Number(form.courseProjectId)"
                              @teacherSelect="handleTeacherChange" 
                              :isDisabled="isDisable"/>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="8">
             <el-form-item label="台上学生："  :required="true" >
                <el-select v-model="form.maxUsers" placeholder="1v2" filterable :disabled="isDisable">
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, index) in studentAmount"
                      :key="index"
                    ></el-option>
                </el-select>
            </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="台下学生："  prop="maxBackupUsers" label-width="100px">
                    <el-input
                        type="maxBackupUsers"
                        v-model.number="form.maxBackupUsers"
                         :disabled="isDisable"
                    ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label=""  :required="true"  label-width="10px">
                    <el-checkbox v-model="form.autoStage"  :disabled="isDisable">学生自动上台</el-checkbox>
                </el-form-item>
            </el-col>
          </el-row>
          

          <el-form-item label="直播课件："  :required="true" > 
            <uploadFile @uploadFile="handleFileChange" :name="'liveIdentifiers'" :list="form.liveFileNames" :isDisabled="isDisable" :sourceType=2 />
          </el-form-item>

          <el-form-item label="课节附件：">
            <uploadFile @uploadFile="handleFileChange" :name="'lessonIdentifiers'" :list="form.lessonFileNames" :isDisabled="isDisable" :sourceType=2 />
          </el-form-item>

          <el-form-item label="回放视频：">
            <uploadFile @uploadFile="handleFileChange" :name="'videoIdentifiers'" :list="form.videoNames" :tips="{image:false,url:true}" :sourceType=1 />
          </el-form-item>

          <el-form-item class="el-form-item-btns">
            <el-button @click="$router.push(`/lesson/${form.courseProjectId}?breadNumber=4`)">取消</el-button>
            <el-button  type="primary" @click="onSubmit">确定</el-button>
          </el-form-item>

          <br />
          <br />
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "newcourse",
  data() {
     var validateOffStage = (rule, value, callback) => {
        if(!value) return;
       setTimeout(() => {
         if (!Number.isInteger(value)) {
           callback(new Error('请输入数字值'));
         } else {
           if (value > 300) {
             callback(new Error('台下人数不能大于300'));
           } else if (value < 0) {
             callback(new Error('台下人数不能小于0'));
           } else {
             callback();
           }
         }
       }, 1000);
    }
    return {
      isDisable:false,
      form: {
        maxUsers:2,
        autoOnStage:false,
        teacher:{id:0},
        assistant:{id:0},
      },
      rules: {
        name: [{ required: true, message: "请输入课节名称", trigger: "blur" }],
        video: [{ required: true }],
        maxBackupUsers:[{type:'number',validator:validateOffStage}]
      },
      studentAmount: [
          {id:2,name:'1v2'},
          {id:3,name:'1v3'},
          {id:4,name:'1v4'},
          {id:5,name:'1v5'},
          {id:6,name:'1v6'},
          {id:7,name:'1v7'},
          {id:8,name:'1v8'},
          {id:9,name:'1v9'},
          {id:10,name:'1v10'},
          {id:11,name:'1v11'},
          {id:12,name:'1v12'}
      ]
    };
  },
  computed: {},
  components: {},
  methods: {
    handleTimeChange(data){
      // console.log(data);
      this.form.lessonsBeginTime = data.bTime
      this.form.lessonsEndTime = data.eTime
    },
    handleTeacherChange(data){
      // console.log(data);
      let type = data.type === 'teacher' ? true : (data.type === 'assistant'? false: '')
      if(type) {
        this.form.teacherId = data.teacherId
        this.form.teacherRole = data.role
      } else {
        this.form.assistantId = data.teacherId
        this.form.assistantRole = data.role
      }
      // console.log(this.form);
    },
    handleFileChange(data){
      // console.log(data);
      this.form[data.name] = data.fileMD5List;
    },
    async onSubmit() {
      this.$refs['form'].validate((valid)=>{
        if(valid) {
          this.commitForm();
        }
      })
    },
    async commitForm() {
      this.form.lessonsName = this.form.name
      this.form.lessonsPattern = this.$route.query.lessonsPattern
      this.form.autoOnStage = this.form.autoStage ? 1 : 0
      this.form.teacherId = this.form.teacherId || this.form.teacher.id || ''
      this.form.assistantId = this.form.assistantId || this.form.assistant.id || ''
      // console.log(this.form);

      let resData = await this.$Api.Course.editLesson(this.form);
      if (resData.data.code === 200) {
        this.$notify({
          title: "成功",
          message: "编辑成功",
          type: "success"
        });
        setTimeout(() => {
          this.$router.push(`/lesson/${this.form.courseProjectId}?breadNumber=4`);
        }, 500);
      } else {
        this.$notify.error({
          title: "错误",
          message: resData.data.msg
        });
      }
    },
    // 获取课节信息
    async getLessonInfo() {
      let id = this.$route.params.id;
      let resData = await this.$Api.Course.getLesson(id);
      // console.log(resData);
      if (resData) {
        this.form = resData.data
        Vue.set(this.form,'autoStage',this.form.autoOnStage == 1 ? true:false)
        this.isDisable = this.dayjs().unix()> this.form.lessonsBeginTime ? true:false
        console.log(this.isDisable)
        if(!this.form.assistant) this.form.assistant = {id:0}
        // console.log(this.form)
      }
    },
  },
  mounted() {
    this.getLessonInfo()
  },
  activated() {
    this.getLessonInfo()
  },
  deactivated() {
    this.form = {
      maxUsers:2,
      autoOnStage:false,
      teacher:{id:0},
      assistant:{id:0},
    }
    this.$refs["form"].resetFields();
  },
  created() {}
};
</script>

<style lang="less"></style>
